// discard-changes.guard.ts

import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { DiscardChangesService } from './core/services/discard-changes.service';
import { DiscardDialogComponent } from './discard-dialog/discard-dialog.component';
import { MatDialog } from '@angular/material/dialog';



@Injectable({
  providedIn: 'root',
})
export class DiscardChangesGuard {
  constructor(private discardChangesService: DiscardChangesService,
    public dialog: MatDialog,
  ) { }


  canActivate(

  ): Observable<boolean> | Promise<boolean> | boolean {
    // Check if the form is dirty
    let isFormDirty = false;
    // Subscribe to form changes
    const subscription = this.discardChangesService?.isFormDirty$.subscribe(
      (value) => {
        console.log(value)
        isFormDirty = value;
      }
    );

    // Display confirmation dialog if the form is dirty
    if (isFormDirty) {
      const dialogRef = this.dialog.open(DiscardDialogComponent, {
        width: '400px',
      });

      return dialogRef.afterClosed().toPromise().then(result => {
        if (result === true) {
          this.discardChangesService.setFormDirty(false);
          return true;
        } else {
          return false;
        }
      });
    }

    // Cleanup and return true if the form is not dirty
    subscription.unsubscribe();
    return true;
  }

}
